import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import type { FaqContent } from "@/types/report";

interface Props {
  content: FaqContent;
}

export function FaqSection({ content }: Props) {
  return (
    <div className="report-faq">
      {content.items.map((item, i) => (
        <details key={i}>
          <summary>{item.question}</summary>
          <div className="faq-answer">
            <Markdown remarkPlugins={[remarkGfm]}>{item.answer}</Markdown>
          </div>
        </details>
      ))}
    </div>
  );
}
